import { render, staticRenderFns } from "./DepositChoice.vue?vue&type=template&id=60bdd605&scoped=true&"
import script from "./DepositChoice.vue?vue&type=script&lang=ts&"
export * from "./DepositChoice.vue?vue&type=script&lang=ts&"
import style0 from "./DepositChoice.vue?vue&type=style&index=0&id=60bdd605&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bdd605",
  null
  
)

export default component.exports